import useAsync from 'react-use/esm/useAsync';
import { githubActionsApiRef } from '../../api/GithubActionsApi.esm.js';
import '@backstage/integration';
import '@octokit/rest';
import { useApi } from '@backstage/core-plugin-api';

const useDownloadWorkflowRunLogs = ({
  hostname,
  owner,
  repo,
  id
}) => {
  const api = useApi(githubActionsApiRef);
  const details = useAsync(async () => {
    return repo && owner ? api.downloadJobLogsForWorkflowRun({
      hostname,
      owner,
      repo,
      runId: id
    }) : Promise.reject("No repo/owner provided");
  }, [repo, owner, id]);
  return details;
};

export { useDownloadWorkflowRunLogs };
//# sourceMappingURL=useDownloadWorkflowRunLogs.esm.js.map
